export default class ModalListChangeClassController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} item
	 */
	constructor($uibModalInstance, item) {
		this.$uibModalInstance = $uibModalInstance;
		this.item = item;
		this.newClass = item.isa;
	}

	cancel() {
		return this.$uibModalInstance.dismiss();
	}

	submit() {
		return this.$uibModalInstance.close(this.newClass);
	}
}
